import { useEffect } from 'react';
import { EventType } from 'types/event-types';
import { DEBT_TICKER } from 'pages/lend/utils';
import { LEND_EVENTS_QUERY } from 'graphql/lend/lendEventsQuery';
import { useSuperGraphPagination } from '../../../../../hooks/api/graphql/supergraph';
import { FETCH_SIZE } from 'pages/feed/components/PropertiesContainer/hooks/useFeedItemsFetcher';
import { STATUS_FILTER } from 'pages/property/components/PropertyActivities/components/PropertyActivityList/hooks/useFetchPropertyActivityList';

const useFinancingActivityFetcher = () => {
  const { data, fetchNextPage, loading, hasMore } =
    useSuperGraphPagination<EventType>(
      LEND_EVENTS_QUERY,
      (data) => data?.events,
      {
        variables: {
          filter: JSON.stringify({
            property_ticker: DEBT_TICKER,
            ...STATUS_FILTER,
          }),
        },
      },
      FETCH_SIZE
    );

  useEffect(() => {
    fetchNextPage();
  }, []);

  return {
    loading,
    data,
    fetchNextPage,
    hasMore,
  };
};

export default useFinancingActivityFetcher;
